import { Navigate } from "react-router-dom"
import { useAuth } from "@/auth/AuthProvider"
import { Button } from "@/components/ui"

export function LoginPage() {
  const { isAuthenticated, signIn } = useAuth()
  if (isAuthenticated) {
    return <Navigate to="/maschinen" replace />
  }
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50">
      <div className="w-full max-w-sm rounded-lg border border-slate-200 bg-white p-8 shadow-sm">
        <h1 className="mb-2 text-xl font-semibold text-slate-900">RMNC Technik</h1>
        <p className="mb-6 text-sm text-slate-600">
          Anmeldung über Logto (user.rmnc.app). Im Logto-Modus (VITE_AUTH_MODE=logto)
          erfolgt der Redirect automatisch — dieser Button dient nur als Fallback,
          falls der automatische Redirect nicht ausgelöst wurde.
        </p>
        <Button onClick={signIn} className="w-full">
          Anmelden
        </Button>
      </div>
    </div>
  )
}
